module.exports = __webpack_public_path__ + "img/pricing-information-clouds-2.1166a28f.png";